import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { updateCustomAppearance } from './slice';
import { AppearanceIncoming } from './types';

export const useUpdateAppearanceSettings = () => {
  const dispatch = useDispatch();

  return useCallback(
    (newValues: AppearanceIncoming) => {
      dispatch(updateCustomAppearance(newValues));
    },
    [dispatch],
  );
};
